/** theme.js
 * 
 * Define your themes' styles in this file and export them
 * so that this file is the SSOT for themes config
 **/

import { createTheme } from "@mui/material/styles";
import { grey } from "@material-ui/core/colors";
import { appConfig } from "./config.js";

// for tokkenr, taken from https://www.figma.com/file/mX042d7Uee8JbQOk7mFEjK/Projet-TokkenR?type=design&node-id=147-106&mode=design&t=SqVHkaA3lmQrGFri-0

const backgroundColor = { main: appConfig.theme.backgroundColor }
const primaryColor = { main: appConfig.theme.primaryColor }
const secondaryColor = { main: appConfig.theme.secondaryColor }

export const theme = createTheme({
    palette: {
        mode: "dark",
        // palette values for dark mode
        // see https://mui.com/customization/dark-mode/#dark-mode-with-custom-palette
        // primary: cyan,
        // divider: cyan[700],
        // background: {
        // 	default: cyan[900],
        // 	paper: cyan[900],
        // },
        primary: primaryColor,
        secondary: secondaryColor,
        divider: primaryColor,
        background: {
            default: backgroundColor,
            paper: "#fff",
        },
        text: {
            primary: "#fff",
            secondary: grey[500],
        },
    },
});
